module.exports = __webpack_public_path__ + "images/help/avatars/snow-7f97b931fefcacee8404e4252d34a60d.jpg";